export const pathPrefix = '/blogs/ask-experian';

interface IRoute {
  HOME: {
    toUrl: (page?: number | null) => string;
  };
  CATEGORY: {
    toUrl: (uri: string, page?: number | null) => string;
  };
  BLOG: {
    toUrl: (uri: string) => string;
  };
  AUTH: {
    toUrl: (uri: string, page?: number | null) => string;
  };
}

const ROUTES: IRoute = {
  HOME: {
    toUrl: (page = null) => (page ? pathPrefix + `/page/${page}/` : pathPrefix + '/')
  },
  CATEGORY: {
    toUrl: (uri: string, page = null) =>
      page ? pathPrefix + uri + `page/${page}/` : pathPrefix + uri
  },
  BLOG: {
    toUrl: (uri: string) => pathPrefix + uri
  },
  AUTH: {
    toUrl: (uri: string, page = null) =>
      page ? pathPrefix + uri + `page/${page}` : pathPrefix + uri
  }
};

export default ROUTES;
